import { useEffect, useState } from "react";
import API from "../../config/api";
import useSeo from "../../hooks/useSeo";
import { useTranslation } from "../../i18n/LanguageProvider";
import { getInitialData } from "../../utils/initialData";
import { getStaticSeoForPath } from "../../utils/seo";
import AdSection from "../../Components/AdSection/AdSection";
import NewsCard from "../../Components/NewsCard/NewsCard";
import { AD_SLOTS } from "../../config/adSlots";
import Title from "../Home/Components/Title/Title";
import "./News.sass";

function NewsListPage() {
    const { language, t } = useTranslation();
    const [news, setNews] = useState(() => getInitialData("newsPage")?.items || []);
    const [loading, setLoading] = useState(() => !getInitialData("newsPage"));

    useSeo(getStaticSeoForPath("/noutati", language));

    useEffect(() => {
        const initialNews = getInitialData("newsPage");

        if (initialNews) {
            setNews(initialNews.items || []);
            setLoading(false);
            return;
        }

        setLoading(true);
        fetch(`${API.getNews}?limit=50&lang=${language}`, {
            credentials: "include",
        })
            .then((res) => res.json())
            .then((data) => setNews(data?.data || []))
            .catch(() => setNews([]))
            .finally(() => setLoading(false));
    }, [language]);

    return (
        <main className="news general-wrapper">
            <Title text={t("news.title")} />
            <p className="news__intro">{t("news.intro")}</p>

            {loading ? (
                <p className="news__loading">{t("news.loading")}</p>
            ) : news.length > 0 ? (
                <>
                    <div className="news__grid">
                        {news.map((item) => (
                            <NewsCard key={item.id} news={item} />
                        ))}
                    </div>
                    <AdSection adSlot={AD_SLOTS.displayInline} adFormat="auto" className="news__ad" />
                </>
            ) : (
                <p className="news__empty">{t("news.empty")}</p>
            )}
        </main>
    );
}

export default NewsListPage;
